module.exports = __webpack_public_path__ + "static/media/Cairo-Regular.4bfda1f4.woff2";